import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/billrun';

export default {

    getSuccessfullBillPeriod() {
        return axios.get(BASE_URL + '/status?success=true&page=0&size=10');
    },

    getFailedBillPeriods() {
        return axios.get(BASE_URL + '/status?success=false&page=0&size=20');
    },

    runBillRun(day) {
        return axios.post(BASE_URL + '/run?day=' + day);
    }

}
